var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabIconExploreNormal = function SvgTabIconExploreNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.75,
    stroke: "#847379",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#847379",
    fillRule: "evenodd",
    d: "M10.04 9.46a1 1 0 0 0-.524.525L7.084 15.66c-.356.83.483 1.669 1.313 1.313l5.674-2.432a1 1 0 0 0 .525-.525l2.432-5.674c.355-.83-.484-1.668-1.313-1.313zm2.1 3.6a1.209 1.209 0 1 0 0-2.418 1.209 1.209 0 0 0 0 2.417",
    clipRule: "evenodd"
  })));
};
export default SvgTabIconExploreNormal;